import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import DecadeBorn from "./MyprofileModal/DecadeBorn";

function MyProfile() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aboutMe, setAboutMe] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    city_id: "",
    occupation: "",
    language: "",
    about_me: "",
  });
  const [uploading, setUploading] = useState(false); // ✅ for image upload
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const [meta,setMeta] = useState();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/user/getuserProfile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        if (res.data && res.data.data) {
          const user = res.data.data;

          setFormData((prev) => ({
            ...prev,
            name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
            dob: user.dob ? user.dob.split(" ")[0] : "",
            gender: user.gender || "",
            country_id: user.country_id || "",
            city_id: user.city || "",
            occupation: user.occupation || "",
            language: user.language || "",
            about_me: user.about_me || "",
            profile_image_url: user.profile_image
              ? `${res.data.base_url}${user.profile_image}` // ✅ full URL
              : null,
          }));
          // ✅ Fetch cities for the user’s country
          if (user.country_id) fetchCities(user.country_id);
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    const fetchCities = async (countryId) => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/get-city-by-country/${countryId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        if (res.data?.status) {
          setCities(res.data.data); // expecting array of {id, name}
        }
      } catch (err) {
        console.error("Error fetching cities:", err);
        setCities([]);
      }
    };
    fetchProfile();
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Save only basic profile info
  const handleSave = async (e) => {
    e.preventDefault();

    if (formData.dob) {
      const today = new Date();
      const birthDate = new Date(formData.dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--; // adjust if birthday hasn't happened yet this year
      }

      if (age < 18) {
        toast.error(
          "You must be at least 18 years old to update your profile."
        );
        return; // Stop submission
      }
    }
    try {
      const res = await toast.promise(
        axios.post(
          `${process.env.REACT_APP_API_BASE}/user/updateUserProfile`,
          {
            name: formData.name,
            dob: formData.dob,
            gender: formData.gender,
            city: formData.city_id,
            occupation: formData.occupation,
            language: formData.language,
            about_me: formData.about_me,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "Content-Type": "application/json",
            },
          }
        ),
        {
          loading: "Profile Updating...",
          success: "Profile Updated successfully",
          error: "Failed to update profile ❌",
        }
      );

      if (res.data.status) {
        const userWithBaseUrl = {
          ...res.data.data,
          base_url: res.data.base_url.replace(/\/$/, ""), // remove trailing slash
        };

        localStorage.setItem("user", JSON.stringify(userWithBaseUrl));
        navigate("/profile", { state: { updated: true } });
        setTimeout(() => window.location.reload(), 200);
      } else {
        // alert(res.data.message || "Failed to update profile.");
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      // alert("Failed to update profile!");
    }
  };

  // ✅ Upload image function (direct onChange se call hoga)
  const handleUploadImage = async (file) => {
    if (!file) return;

    // ✅ File size check (2MB = 2048 KB)
    const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
    if (file.size > maxSize) {
      toast.error("The profile image must not be greater than 2048 KB (2 MB).");
      file.target.value = "";
      return; // ❌ Stop upload if too large
    }

    const fd = new FormData();
    fd.append("profile_image", file);

    try {
      setUploading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/user/updateProfileImage`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status) {
        toast.success("Profile image updated successfully!");
        if (res.data.image_url) {
          setFormData((prev) => ({
            ...prev,
            profile_image_url: res.data.image_url,
            profile_image: null,
          }));
        }

        const userWithBaseUrl = {
         ...res.data.data.user,
         base_url: res.data.base_url
      };
     
         localStorage.setItem("user", JSON.stringify(userWithBaseUrl));
          window.location.reload();
      } else {
        toast.error(res.data.message || "Failed to upload image.");
      }
    } catch (err) {
      console.error("Error uploading image:", err);
      toast.error("Failed to upload image!");
    } finally {
      setUploading(false); // stop loader
    }
  };

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("profile");
      setMeta(data);
    };

    loadMeta();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <section className="mng_bottomss user_allls profiles all_titless myprofiless">
         <SetMetaTags
        title= {meta?.meta_title || "Profile | Weyfarin"}
        description={meta?.meta_description || "Profile | Weyfarin"}
      
      />

        <div className="bedcramss">
          {" "}
          <Link to="/profile">Profile</Link> &gt; My Profile
        </div>
        <div className="prfo_listst lastsst al_sec_ctxt pt-4">
          <div className="row">
            <div className="col-lg-2">
              <div className="usr_profl text-center edtiss">
                <div className="usr_mgss">
                  {formData.profile_image ? (
                    <img
                      src={URL.createObjectURL(formData.profile_image)}
                      alt="Profile Preview"
                    />
                  ) : formData.profile_image_url ? (
                    <img src={formData.profile_image_url} alt="Profile" />
                  ) : (
                    <img src="images/user_dh.png" alt="default" />
                  )}
                </div>
                <div className="edit_pencilss">
                  <input
                    type="file"
                    name="profile_image"
                    accept="image/*"
                    id="profileUpload"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const maxSize = 2 * 1024 * 1024; // 2 MB
                        if (file.size > maxSize) {
                          toast.error(
                            "The profile image must not be greater than 2048 KB (2 MB)."
                          );
                          e.target.value = ""; // ✅ Reset input if too large
                          return;
                        }
                        setFormData((prev) => ({
                          ...prev,
                          profile_image: file,
                        }));
                        // ✅ Select karte hi upload
                        handleUploadImage(file);
                      }
                    }}
                  />
                  <label
                    htmlFor="profileUpload"
                    style={{
                      // cursor: "pointer",
                      cursor: uploading ? "not-allowed" : "pointer",
                    }}
                  >
                    <img src="/images/Pencils.png" alt="" />
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="discriptionns">
                <h3>My Profile</h3>
                <p className="sm_diss">
                  Hosts and guests can see your profile and it may appear across
                  Weyfarin to help us build trust in our community. 
                  <Link to={"/about"}>Learn more</Link>
                </p>
              </div>

              <div className="form_al_fildss">
                <form onSubmit={handleSave}>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          value={formData.name}
                          onKeyPress={(e) => {
                            const regex = /^[A-Za-z ]+$/;
                            if (!regex.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={30}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Date of Birth</label>
                        <input
                          className="form-control"
                          type="date"
                          name="dob"
                          value={formData.dob}
                          max={new Date().toISOString().split("T")[0]}
                          onClick={(e) => {
                            if (e.target.showPicker) {
                              e.target.showPicker(); // ✅ Opens calendar on click
                            }
                          }}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Gender</label>
                        <select
                          className="form-control"
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>City</label>
                        <select
                          className="form-control"
                          name="city_id"
                          value={formData.city_id}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          {cities.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name} {/* name shown to user */}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Occupation</label>
                        <input
                          className="form-control"
                          type="text"
                          name="occupation"
                          value={formData.occupation}
                          onChange={handleChange}
                          maxLength={50}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Languages</label>
                        <input
                          className="form-control"
                          type="text"
                          name="language"
                          value={formData.language}
                          onKeyPress={(e) => {
                            const regex = /^[A-Za-z ]+$/;
                            if (!regex.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={50}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="discriptionns">
                        <h3>About me</h3>
                        <div className="form-group managess">
                          <textarea
                            className="form-control"
                            name="about_me"
                            placeholder="Write something about yourself"
                            rows="4"
                            value={formData.about_me}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="submmit">
                        <button type="submit" value="submit">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DecadeBorn
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        aboutMe={aboutMe}
        setAboutMe={setAboutMe}
        onSave={handleSave}
      />
    </>
  );
}

export default MyProfile;
